import AnimeList from "../Components/AnimeList";
import '../CSS/Index.css';

function Index() {
    return (
        <div className="Index">
            <AnimeList />

        </div>
    )
}

export default Index;